// @ts-nocheck
import { faCogs, faListUl, faRocket, faThLarge, faUserFriends, faPlug, faCloudUploadAlt, faHeartbeat, faWrench, faMagic, faBrain, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import * as React from "react";
import { ConfigProvider } from 'antd';
import { Admin, Resource } from 'react-admin';
import Applications from './components/Applications';
import ChangeInstances from './components/ChangeInstances';
import Dashboard from "./components/Dashboard";

import Webhooks from "./components/Webhooks";
import Healthchecks from "./components/Healthchecks";
import FaIcon from "./components/Icons/FaIcon";
import Layout from './components/Layout';
import LoginPage from './components/Login/LoginPage';
import ServiceCatalogue from "./components/ServiceCatalogue";
import ServiceItems from './components/ServiceItems';
import Submissions from './components/Submissions';
import ServiceOwnerChangeInstances from './components/ServiceOwnerChangeInstances';
import ServiceOwnerServiceItems from "./components/ServiceOwnerServiceItems";
import Services from './components/Services';
import Teams from './components/Teams';
import Marketplace from "./components/Marketplace";
import Messages from "./components/OrcaExternal/Messages";
import drfProvider, { fetchJsonWithAuthToken, tokenAuthProvider } from './providers/dataProvider';
import uiReducer from './reducers/ui';
import Routes from './routes';
import 'antd/dist/reset.css';
import './assets/css/tokens.css';
import './assets/css/base.css';
import './assets/css/motion.css';
import './assets/css/antd-overrides.css';
import './assets/css/main.css';

import { GoogleOAuthProvider } from '@react-oauth/google';
import LLMModels from "@src/components/LLMModels";
import Settings from "@src/components/Settings";
import { isFeatureEnabled } from './components/Settings/Features';
import { motionEnabled, usePrefersReducedMotion } from './components/Common/motion';
import BuilderWizard from './components/SubmissionBuilder/BuilderWizard';
import AIProcessors from "@src/components/AIProcessors";
import AIIntegration from "@src/components/AIIntegration";
import PackDashboard from "@src/components/Pack/PackDashboard"
import Pipelines from "@src/components/Pack/Pipelines";
import Documents from "@src/components/Pack/Documents";

const dataProvider = drfProvider(process.env.API_URL, fetchJsonWithAuthToken)
const authProvider = tokenAuthProvider();

const getResources = (permissions: string) => {
  const resources = [
    <Resource key="teams" name="teams" {...Teams} icon={FaIcon(faUserFriends)} options={{ belowFold: true }} />,
    // No views of their own: the Members and API Keys tabs of the team page
    // list them, and a list only keeps its records once its resource is
    // registered — without this they load and are thrown away.
    <Resource key="team_memberships" name="team_memberships" options={{ viewMode: false, label: 'Team Members' }} />,
    // Registration only, so the admin view's member list has a redux slice of
    // its own and keeps its filters apart from the team's own Members tab,
    // which reads the same endpoint. viewMode false keeps it out of the menu.
    <Resource key="admin_team_memberships" name="admin_team_memberships" options={{ viewMode: false, label: 'Team Members' }} />,
    <Resource key="apikeys" name="apikeys" options={{ viewMode: false, label: 'API Keys' }} />,
    <Resource key="services" name="services" {...Services} icon={FaIcon(faRocket)} options={{ viewMode: 'SERVICE_OWNER' }} />,
    <Resource key="browse_services" name="browse_services" {...ServiceCatalogue} icon={FaIcon(faListUl)} options={{ viewMode: 'CONSUMER', label: 'Service Catalogue' }} />,
    <Resource key="submissions" name="submissions" {...Submissions} icon={FaIcon(faCloudUploadAlt)} options={{ viewMode: 'CONSUMER', belowFold: true, label: 'Submissions' }} />,
    <Resource key="service_items" name="service_items" {...ServiceItems} icon={FaIcon(faRocket)} options={{ viewMode: 'CONSUMER', label: 'Service Items' }} />,
    <Resource key="owner_service_items" name="owner_service_items" {...ServiceOwnerServiceItems} icon={FaIcon(faListUl)} options={{ viewMode: 'SERVICE_OWNER', label: 'Service Items' }} />,
    <Resource key="applications" name="applications" {...Applications} icon={FaIcon(faThLarge)} options={{ viewMode: 'CONSUMER' }} />,
    <Resource key="change_instances" name="change_instances" {...ChangeInstances} icon={FaIcon(faCogs)} options={{ viewMode: 'CONSUMER', label: 'Change Instances' }} />,
    <Resource key="owner_change_instances" name="owner_change_instances" {...ServiceOwnerChangeInstances} icon={FaIcon(faCogs)} options={{ viewMode: 'SERVICE_OWNER', label: 'Change Instances' }} />,
    <Resource key="serviceowner_pack_statistics" name="serviceowner_pack_statistics" {...PackDashboard} icon={FaIcon(faBrain)} options={{ viewMode: false, label: 'AI Integration', feature: "AIIntegration" }} />,
    <Resource key="serviceowner_ai_processors" name="serviceowner_ai_processors" {...AIProcessors} icon={FaIcon(faPlug)}  options={{ viewMode: false, feature: "AIIntegration", label: "AI Processors" }} />,
    <Resource key="llm_models" name="llm_models" {...LLMModels} icon={FaIcon(faPlug)} options={{ viewMode: false, feature: "AIIntegration", label: "LLM Models" }} />,
    <Resource key="serviceowner_pack_pipelines" name="serviceowner_pack_pipelines" {...Pipelines} icon={FaIcon(faBrain)} options={{ viewMode: 'SERVICE_OWNER', feature: "AIIntegration", label: "AI Integration" }} />,
    <Resource key="serviceowner_pack_documents" name="serviceowner_pack_documents" {...Documents} icon={FaIcon(faPlug)} options={{ viewMode: false, feature: "AIIntegration", label: "Documents"}} />,
    <Resource key="webhooks" name="webhooks" {...Webhooks} icon={FaIcon(faPlug)} options={{ viewMode: 'SERVICE_OWNER', label: 'Webhooks' }} />,
    <Resource key="serviceowner_healthchecks" name="serviceowner_healthchecks" {...Healthchecks} icon={FaIcon(faHeartbeat)} options={{ viewMode: 'SERVICE_OWNER', label: 'Healthchecks' }} />,
    // No views of their own: the Responses tab of the two pages above lists
    // them, and a list only keeps its records once its resource is registered.
    <Resource key="webhook_responses" name="webhook_responses" options={{ viewMode: false, label: 'Webhook Responses' }} />,
    <Resource key="serviceowner_healthcheck_responses" name="serviceowner_healthcheck_responses" options={{ viewMode: false, label: 'Healthcheck Responses' }} />,
    <Resource key="serviceowner_charges" name="serviceowner_charges" {...Marketplace} icon={FaIcon(faFileInvoiceDollar)} options={{ viewMode: 'SERVICE_OWNER', label: 'Charges', feature: "Charges" }} />,
    <Resource key="consumer_charges" name="consumer_charges" {...Marketplace} icon={FaIcon(faFileInvoiceDollar)} options={{ viewMode: 'CONSUMER', label: 'Charges', feature: "Charges" }} />,
    <Resource key="serviceowner_messages" name="serviceowner_messages" {...Messages} options={{ 'viewMode': false, label: "Service Owner Messages" }}/>,
    <Resource key="general_settings" name="general_settings" {...Settings} icon={FaIcon(faWrench)} options={{ viewMode: 'SUPERUSER', label: 'General Settings' }} />,
    <Resource key="submission_builder" name="submission_builder" list={BuilderWizard} icon={FaIcon(faMagic)} options={{ viewMode: 'CONSUMER', label: 'Submission Builder', feature: 'SubmissionBuilder' }} />
  ];

  const finalResources = resources.filter(resource => {
    if (!resource.props.options?.feature) return true;
    return isFeatureEnabled(resource.props.options.feature, resource.props.options?.viewMode, permissions);
  });

  return finalResources
};

// One switch, three places it has to reach: antd's own component motion (the
// `motion` seed token below), our CSS (the [data-motion='off'] rule this
// attribute triggers), and the presence hook that animates panels out.
if (!motionEnabled && typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-motion', 'off');
}

const antdTheme = {
  token: {
    motion: motionEnabled,
    colorPrimary: '#5796cc',
    colorLink: 'hsl(208, 53%, 57%)',
    colorTextHeading: 'rgba(0, 0, 0, 0.87)',
    colorText: '#595959',
    colorTextSecondary: '#737373',
    colorTextDisabled: '#bfbfbf',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    controlHeight: 32,
  },
  components: {
    Menu: {
      itemMarginInline: 0,
      itemMarginBlock: 0,
      itemBorderRadius: 0,
    },
    Card: {
      bodyPadding: 16,
    }
  }
};

const App_ = () => {
  // Under the OS reduced-motion setting antd is switched off outright rather
  // than left to base.css: the popups then appear in place instead of playing
  // a motion cut to nothing.
  const reducedMotion = usePrefersReducedMotion();
  const theme = React.useMemo(
    () => (reducedMotion ? { ...antdTheme, token: { ...antdTheme.token, motion: false } } : antdTheme),
    [reducedMotion],
  );

  return (
  <ConfigProvider theme={theme}>
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    disableTelemetry
    dashboard={Dashboard}
    customRoutes={Routes}
    initialState={{ admin: { ui: { sidebarOpen: false } } }}
    customReducers={{ ui: uiReducer }}
    layout={Layout}
    loginPage={LoginPage}
  >
    {(permissions) => getResources(permissions)}
  </Admin>
  </ConfigProvider>
  );
};

const App = () => {
  return (
    process.env.GOOGLE_OAUTH_CLIENT_ID ?
      <GoogleOAuthProvider clientId={process.env.GOOGLE_OAUTH_CLIENT_ID}>
        <App_ />
      </GoogleOAuthProvider>
      :
      <App_ />
  )
}

export default App;